'use client';

import IconLabel from '../IconLabel/IconLabel';
import { IconPeopleGroup } from '@justgiving/carepack-icons';
import { ProductNames } from '../../constants/ProductNames';
import React from 'react';
import clientConfig from '../../client/config';
import { useIsPageOwner } from '../../hooks/useIsPageOwner';
import { usePage } from '../Providers/PageProvider';
import { useTranslation } from 'react-i18next';

export const CreateTeam: React.FC = () => {
  const { t } = useTranslation();
  const isPageOwner = useIsPageOwner();
  const { id, product } = usePage();

  const isTeamProduct = [ProductNames.Team, ProductNames.ProxyTeam].includes(
    product.name as ProductNames,
  );

  if (!isPageOwner || isTeamProduct) {
    return null;
  }

  return (
    <IconLabel>
      <IconLabel.Icon>
        <IconPeopleGroup />
      </IconLabel.Icon>
      <IconLabel.Label>
        <a
          className="cp-text-link"
          href={`${clientConfig.justGivingRootUrl}/teams-creation?pageId=${id}`}
        >
          {t('team.createTeam')}
        </a>
      </IconLabel.Label>
    </IconLabel>
  );
};
